module.exports = __webpack_public_path__ + "img/about-b-slide5.29552a9e.jpg";